import { useMutation } from 'react-query';
import {
  INextError,
  LoggerInstance,
  cerebroClient,
  getHeadersCerebro,
} from '@vfit/shared/data-access';
import { datadogRum } from '@datadog/browser-rum';
import { ICDACheckStatus } from './cdaCheck.models';

const cdaCheck = (endpoint = 'onboarding/checkStatus') => {
  datadogRum.addAction('HTTP Request', {
    type: 'CONSUMER',
    method: 'GET',
    url: endpoint,
    body: {},
  });
  return cerebroClient.get(endpoint, {
    headers: {
      ...getHeadersCerebro(),
    },
  }) as Promise<ICDACheckStatus>;
};

export const useCDACheck = () => {
  return useMutation(['useCDACheck'], ({ endpoint }: { endpoint?: string }) => cdaCheck(endpoint), {
    onSuccess: (data: ICDACheckStatus) => {
      LoggerInstance.info(`SUCCESS useCDACheck: `, data);
      datadogRum.addAction('HTTP Response', {
        type: 'onboarding',
        url: 'onboarding/checkStatus',
        status: '200',
        response: data,
      });
    },
    onError: (error: INextError) => {
      LoggerInstance.error(`ERROR on useCDACheck: `, error);
    },
  });
};
